import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Role } from '../types';
import { Landmark, Shield } from 'lucide-react';
export const LoginPage: React.FC = () => {
  const [selectedRole, setSelectedRole] = useState<Role>('operator');
  const {
    login
  } = useAuth();
  const navigate = useNavigate();
  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    login(selectedRole);
    navigate('/');
  };
  return <div className="min-h-screen flex flex-col justify-center py-12 sm:px-6 lg:px-8 relative" style={{
    backgroundImage: `linear-gradient(rgba(0, 50, 20, 0.55), rgba(0, 40, 15, 0.7)), url('https://images.unsplash.com/photo-1500382017468-9049fed747ef?q=80&w=2232&auto=format&fit=crop')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundAttachment: 'fixed'
  }} data-id="element-1055">
      <div className="sm:mx-auto sm:w-full sm:max-w-md relative z-10" data-id="element-1056">
        <div className="flex justify-center" data-id="element-1057">
          <div className="h-16 w-16 bg-white/90 rounded-full flex items-center justify-center shadow-lg backdrop-blur-sm" data-id="element-1058">
            <Landmark className="text-green-700" size={32} data-id="element-1059" />
          </div>
        </div>
        <h2 className="mt-6 text-center text-2xl font-bold text-white drop-shadow-lg" data-id="element-1060">
          জরিপ খতিয়ান প্রকাশনা
        </h2>
        <p className="mt-2 text-center text-sm text-green-100 font-medium drop-shadow" data-id="element-1061">
          ভূমি রেকর্ড ও জরিপ অধিদপ্তর (ডিএলআরএস)
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md relative z-10" data-id="element-1062">
        <div className="bg-white py-8 px-4 shadow-2xl sm:rounded-lg sm:px-10 border-t-4 border-teal-600" data-id="element-1063">
          <div className="mb-6 flex items-center justify-center space-x-2 text-slate-600 bg-slate-50 py-2 rounded-md border border-slate-200" data-id="element-1064">
            <Shield size={16} data-id="element-1065" />
            <span className="text-xs font-semibold uppercase tracking-wider" data-id="element-1066">
              অনুমোদিত জোন
            </span>
          </div>

          <form className="space-y-6" onSubmit={handleLogin} data-id="element-1067">
            <div data-id="element-1068">
              <label htmlFor="role" className="block text-sm font-medium text-slate-700" data-id="element-1069">
                ভূমিকা নির্বাচন করুন (ডেমো)
              </label>
              <div className="mt-1" data-id="element-1070">
                <select id="role" name="role" className="input-field" value={selectedRole} onChange={e => setSelectedRole(e.target.value as Role)} data-id="element-1071">
                  <option value="operator" data-id="element-1072">সেটেলমেন্ট প্রেস অপারেটর</option>
                  <option value="officer" data-id="element-1073">সেটেলমেন্ট প্রেস অফিসার</option>
                  <option value="zso" data-id="element-1074">জোনাল সেটেলমেন্ট অফিসার (জেডএসও)</option>
                  <option value="admin" data-id="element-1075">পরিচালক (ভূমি রেকর্ড)</option>
                  <option value="dsminland" data-id="element-1076">ডিএস ভূমি মন্ত্রণালয়</option>
                </select>
              </div>
            </div>

            <div data-id="element-1077">
              <label htmlFor="username" className="block text-sm font-medium text-slate-700" data-id="element-1078">
                ব্যবহারকারীর নাম
              </label>
              <div className="mt-1" data-id="element-1079">
                <input id="username" name="username" type="text" disabled value={`demo_${selectedRole}`} className="input-field bg-slate-50 text-slate-500" data-id="element-1080" />
              </div>
            </div>

            <div data-id="element-1081">
              <label htmlFor="password" className="block text-sm font-medium text-slate-700" data-id="element-1082">
                পাসওয়ার্ড
              </label>
              <div className="mt-1" data-id="element-1083">
                <input id="password" name="password" type="password" disabled value="********" className="input-field bg-slate-50 text-slate-500" data-id="element-1084" />
              </div>
            </div>

            <div data-id="element-1085">
              <button type="submit" className="w-full btn-primary flex justify-center py-2.5" data-id="element-1086">
                সিস্টেমে প্রবেশ করুন
              </button>
            </div>
          </form>

          <div className="mt-6 text-center text-xs text-slate-500" data-id="element-1087">
            গণপ্রজাতন্ত্রী বাংলাদেশ সরকার
          </div>
        </div>
      </div>
    </div>;
};